import { fetch } from "../utils/scsFetch";
import { URL_SURVEY_API } from '../utils/constEnvVariables'

export const getCOOSurveyPartsBySupplier = async (suppliers, campaignId, accessToken) => {
  if(campaignId && Array.isArray(suppliers) && suppliers.length > 0 && accessToken){
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            suppliers: suppliers,
            campaignId: campaignId
        })
    }

    return fetch(`${URL_SURVEY_API}/surveys/coo/parts/`, requestOptions)
  }
  return undefined
}

export const submitCOOResponse = function (request, accessToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/coo/response`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getCOOResponsesByAssignment = function (assignmentId, accessToken) {
  return fetch(`${URL_SURVEY_API}/surveys/coo/responses/${assignmentId}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }).then(res => { return res })
      .catch(error => {
          console.log(error);
          //There is not answers in db yet
          return [];
      })
}

export const getCOOResponseById = function (responseId, accessToken) {
  return fetch(`${URL_SURVEY_API}/surveys/coo/response/${responseId}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }).then(res => { return res })
      .catch(error => {
          console.log(error);
          //There is not answers in db yet
          return [];
      })
}

export const deleteCOOResponseByResponseId = function (responseId, accessToken) {
  const requestOptions = {
      method: 'DELETE',
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }

  return fetch(`${URL_SURVEY_API}/surveys/coo/response/${responseId}`, requestOptions)
      .then(response => {
          return response
      })
      .catch(error => { throw error });
}


export const saveCooAnswers = function (request, accessToken) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/coo/answer`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

